import { Routes, Route } from "react-router-dom";
import HeaderAnimated from './HeaderAnimated';
import HeaderMobile from './HeaderMobile';
import HeaderStatic from './HeaderStatic';

const Header = ({ color }) => {
  return (
    <div className="header">
      <Routes>
        <Route path="/" element={
          (
            <>
              <HeaderMobile color={color} />
              <HeaderAnimated color={color} />
            </>
            )
          }
        />
        <Route path="*" element={(<HeaderStatic color={color} />)} />
      </Routes>
      <h1 className="sr-only">Pafiume Jewelry</h1>
    </div>
  );
};

export default Header;
